const DISPLAY_BY_STATUS_OPTIONS = [
   {
      value: 'all',
      label: 'All',
      id: 'all',
      name: 'all',
   },
   {
      value: 'active',
      label: 'Active',
      id: 'active',
      name: 'active',
   },
   {
      value: 'inactive',
      label: 'Inactive',
      id: 'inactive',
      name: 'inactive',
   },
];

export default DISPLAY_BY_STATUS_OPTIONS;
